import React from 'react';
import { observer } from 'mobx-react';
import { MailerliteGroupStore } from '@seedlang/stores';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import InfoTooltip from 'components/info_tooltip';
import { computed } from 'mobx';
import Spinner from 'components/spinner';
import autobind from 'autobind-decorator';
import Stack from 'components/layout/stack';
import ButtonPrimary from 'components/button/button_primary';
import PageTitle from 'components/common/page_title';

@observer
class MailerliteGroupIndex extends React.Component {
  componentDidMount() {
    MailerliteGroupStore.getIndex();
  }

  componentWillUnmount() {
    MailerliteGroupStore.clearIndexData();
  }

  @computed get groups() {
    return MailerliteGroupStore.indexData ?? [];
  }

  @computed get isLoading() {
    return MailerliteGroupStore.requestCounter > 0;
  }

  @autobind
  handleSync() {
    MailerliteGroupStore.sync({}, () => MailerliteGroupStore.getIndex());
  }

  render() {
    return (
      <Stack gap='md'>
        <PageTitle>MailerLite Groups</PageTitle>
        <h3>MailerLite Groups</h3>
        <ButtonPrimary
          onClick={this.handleSync}
          disabled={this.isLoading}
        >
          Sync Groups
        </ButtonPrimary>
        {this.isLoading ? (
          <Spinner />
        ) : this.groups.length === 0 ? (
          <p>There are no MailerLite groups for this site.</p>
        ) : (
          <table className='table-wrapper admin-table'>
            <thead>
              <tr>
                <th>Name</th>
                <th>
                  Never Delete Users
                  <InfoTooltip>
                    If checked, users in this group will not be deleted
                    from MailerLite if they delete their account.
                  </InfoTooltip>
                </th>
              </tr>
            </thead>
            <tbody>
              {
                this.groups.map(item => {
                  return (
                    <tr key={item.id}>
                      <td>
                        {item.name}
                      </td>
                      <td>
                        <InPlaceCheckbox
                          model='mailerlite_groups'
                          field='api_should_never_delete'
                          value={item.apiShouldNeverDelete}
                          id={item.id}
                        />
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        )}
      </Stack>
    );
  }
}

export default MailerliteGroupIndex;